import { apiRequest } from '@/shared/api';

import type { Achievement } from '../model/types';

export function fetchAchievements(): Promise<Achievement[]> {
  return apiRequest<Achievement[]>('/achievements');
}
